import { track } from "@/lib/analytics";

export default function FinalCta() {
  return (
    <section className="relative bg-background-50 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://joble.app/images/bg.png"
          alt=""
          aria-hidden
          className="w-full h-full object-cover object-bottom opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-background-50/70 to-background-50"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[720px] h-[520px] rounded-full joble-glow-accent"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-8 py-24 md:py-28 text-center">
        <div className="reveal inline-flex items-center gap-2 rounded-full border border-background-300/40 bg-background-100/50 px-4 py-1.5 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-xs font-medium text-foreground-800 tracking-wide">
            Try Joble today
          </span>
        </div>

        <h2 className="reveal font-heading text-4xl sm:text-5xl md:text-6xl font-medium text-foreground-950 leading-[1.1] tracking-tight max-w-3xl mx-auto">
          Your customers are already trying to reach you.
        </h2>
        <p className="reveal mt-6 text-base md:text-lg text-foreground-700 leading-relaxed max-w-xl mx-auto">
          Answer every one of them. Start your trial in five minutes, no credit card, no developer,
          no risk.
        </p>

        <div className="reveal mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://app.joble.app/auth/create-account?free=true"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("try_joble_clicked", { location: "final_cta" })}
            className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 rounded-full bg-primary-500 text-foreground-950 font-semibold text-base px-9 py-4 hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Try Joble Now
            <span className="w-7 h-7 rounded-full bg-foreground-950/15 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
              <i className="ri-arrow-right-line text-foreground-950" aria-hidden></i>
            </span>
          </a>
          <a
            href="#get-started"
            onClick={() => track("talk_to_sales_clicked", { location: "final_cta" })}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border border-background-300/60 text-foreground-900 font-semibold text-base px-9 py-4 hover:bg-background-100/70 transition-colors cursor-pointer whitespace-nowrap"
          >
            Talk to sales
          </a>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs md:text-sm text-foreground-600 font-medium tracking-wide">
          <span className="flex items-center gap-2">
            <i className="ri-check-line text-primary-400" aria-hidden></i> Free 5-minute setup
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-check-line text-primary-400" aria-hidden></i> No credit card
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-check-line text-primary-400" aria-hidden></i> Cancel anytime
          </span>
        </div>
      </div>
    </section>
  );
}